/* eslint-disable max-len */
// Dependencies
import React from 'react'
import {connect} from 'react-redux'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesVideoRender from '../styles/VideoRender.module.css'

// Components

function VideoRender(props) {
  return (
    <div
      className={stylesVideoRender['video-render']}
    >
      <video controls src={URL.createObjectURL(props.file)} type={props.file?.type}/>
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
})

export default connect(
    mapStateToProps,
    {},
)(VideoRender)
